
<button @click="$emit('input', !value)" :disabled="!configurable">
  <span class="icon" :class="value ? 'locked' : 'unlocked'" v-tooltip="computedTooltip"></span>
</button>
